import Layout from 'src/views/components/layout/'

function getView(viewName, title) {
    return (resolve, reject) => {
        require.ensure([], (require) => {
            let modules = require(`src/views/page/account/${viewName}`)
            modules.default.options.metaInfo = { title }
            resolve(modules)
        }, reject, 'account')
    }
}

let routes = {
    name: 'auth',
    path: '/auth',
    redirect: '/auth/realName-auth',
    component: Layout,
    meta: {
        title: '认证管理',
        icon: 'icon-uc-authentication'
    },
    sort: 2,
    children: [
        {
            name: 'realName-auth',
            path: 'realName-auth',
            meta: {
                title: '实名认证',
                noCache: true
            }
        },
        {
            name: 'user-auth',
            path: 'user-auth',
            meta: {
                title: '企业认证',
                noCache: true
            }
        }
    ]
}

routes.children.forEach((v) => {
    if (!v.redirect && !v.component) {
        v.component = getView(v.name, v.meta.title)
    }
})

export default [routes]



// WEBPACK FOOTER //
// ./src/router/modules/account-center/auth-manager/auth.js